import { type FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useRootSelector } from "@ds/hooks";
import { useCurrentProjectFeatureEnabled, useIsCurrentProjectFeaturesLoaded } from "@ds/hooks/use-feature";

import { FEATURE_KEYS } from "@ds/modules/features/@types";

import { CONTENT_CAMPAIGNS_SEGMENT, CONTENT_PLAYLISTS_ROUTE, CONTENT_PLAYLISTS_SEGMENT } from "@ds/constants/router";

import { CampaignsRouter } from "./campaigns/campaigns-router";
import { PlaylistsRouter } from "./playlists/playlists-router";
import { selectCurrentView } from "./redux/selectors";

const ContentRouteSwitch = () => {
  const currentView = useRootSelector(selectCurrentView);
  const isCampaignsEnabled = useCurrentProjectFeatureEnabled(FEATURE_KEYS.CAMPAIGNS);
  const isFeaturesLoaded = useIsCurrentProjectFeaturesLoaded();

  if (!isFeaturesLoaded) {
    return null;
  }

  if (currentView && (isCampaignsEnabled || currentView !== CONTENT_CAMPAIGNS_SEGMENT)) {
    return <Navigate to={currentView} replace />;
  }

  return <Navigate to={isCampaignsEnabled ? CONTENT_CAMPAIGNS_SEGMENT : CONTENT_PLAYLISTS_SEGMENT} replace />;
};

export const ContentRouter: FC = () => {
  const isCampaignsEnabled = useCurrentProjectFeatureEnabled(FEATURE_KEYS.CAMPAIGNS);
  const isFeaturesLoaded = useIsCurrentProjectFeaturesLoaded();

  if (!isFeaturesLoaded) {
    return null;
  }

  return (
    <Routes>
      <Route path="*" element={<ContentRouteSwitch />} />
      <Route
        path={`${CONTENT_CAMPAIGNS_SEGMENT}/*`}
        element={isCampaignsEnabled ? <CampaignsRouter /> : <Navigate to={CONTENT_PLAYLISTS_ROUTE} replace />}
      />
      <Route path={`${CONTENT_PLAYLISTS_SEGMENT}/*`} element={<PlaylistsRouter />} />
    </Routes>
  );
};
